import React from "react";
import ToggleButton from "@mui/material/ToggleButton";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Alert from "@mui/material/Alert";
import Tooltip, { tooltipClasses } from "@mui/material/Tooltip";
import CircularProgress from "@mui/material/CircularProgress";

export const WeeklySummaryBox = styled(Box)(({ theme }) => ({
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "white",
  boxShadow: 24,
  padding: 24,
  borderRadius: 8,
  outline: "none",
  color: "black",
  overflowY: "auto",

  [theme.breakpoints.down("md")]: {
    width: "100%",
    height: "100%",
  },

  h3: {
    fontWeight: 600,
    fontSize: 24,
    lineHeight: "38.4px",
    [theme.breakpoints.down("md")]: {
      marginTop: 48,
    },
  },
  ".weekly-summary": {
    "&__subtitle": {
      fontWeight: 400,
      fontSize: 15,
      lineHeight: "24px",
      marginBottom: 40,
    },
    "&__thread": {
      borderBottom: "1px solid rgba(0, 0, 0, .1)",
      ":last-child": {
        borderBottom: 0,
      },
    },
  },
}));

export const ThreadBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-between",
  marginTop: 15,
  marginBottom: 15,
  alignItems: "center",

  [theme.breakpoints.down("md")]: {
    flexDirection: "column",
    alignItems: "start",
    gap: 10,
  },
}));

export const ThreadInfoBox = styled(Box)({
  ".weekly-summary": {
    "&__thread": {
      "&--info": {
        color: "black",
        fontSize: 16,
        fontWeight: 600,
        lineHeight: "25.6px",

        "> span": {
          fontWeight: 400,
        },
      },
      "&--user": {
        color: "black",
        fontWeight: 400,
        fontSize: 15,
        lineHeight: "24px",
      },
    },
  },
});

const ToggleButtonBase = styled(ToggleButton)({
  color: "#424242",
  padding: "6px 15px",
  textTransform: "none",
  fontSize: 14,
  letterSpacing: "0.4px",
  ":hover": {
    color: "white",
  },
  "&.Mui-selected": {
    color: "white",
    boxShadow:
      "0px 3px 1px -2px rgba(0, 0, 0, 0.2), 0px 2px 2px rgba(0, 0, 0, 0.14), 0px 1px 5px rgba(0, 0, 0, 0.12)",
  },
});

export const BookedButton = styled(ToggleButtonBase)({
  border: "1px solid #3C3E42",
  borderRadius: "666px 0 0 666px",
  ":hover": {
    backgroundColor: "#30481D",
  },
  "&.Mui-selected": {
    backgroundColor: "#45682A",
    ":hover": {
      backgroundColor: "#45682A",
    },
  },
  ".MuiSvgIcon-root": {
    marginRight: "10px",
  },
});

export const DeclinedButton = styled(ToggleButtonBase)({
  border: "1px solid #3C3E42",
  borderRadius: "0 666px 666px 0 !important",
  borderLeft: "1px solid #3C3E42 !important",
  ":hover": {
    backgroundColor: "#821E15",
  },
  "&.Mui-selected": {
    backgroundColor: "#BB2C1F",
    ":hover": {
      backgroundColor: "#BB2C1F",
    },
  },
  ".MuiSvgIcon-root": {
    marginRight: "10px",
  },
});

export const OngoingButton = styled(ToggleButtonBase)({
  border: 0,
  borderRadius: "666px !important",
  marginLeft: "8px !important",
  ":hover": {
    backgroundColor: "#310096",
  },
  "&.Mui-selected": {
    backgroundColor: "#4700D7",
    ":hover": {
      backgroundColor: "#4700D7",
    },
  },
});

export const ButtonBox = styled(Box)({
  display: "flex",
  flexDirection: "row",
  padding: "15px 0",
  justifyContent: "flex-end",
  gap: 10,
});

export const VenueTitle = styled(Box)({
  fontWeight: 600,
  fontSize: 20,
  lineHeight: "32px",
  "&:not(first-child)": {
    marginTop: "48px",
  },
});

export const ThreadsList = styled(Box)(({ theme }) => ({
  maxHeight: 330,
  [theme.breakpoints.down("md")]: {
    maxHeight: "none",
  },
}));

export const OngoingSelectedAlert = styled(Alert)({
  marginTop: 40,
  borderRadius: 5,
  fontWeight: 400,
  fontSize: 15,
  lineHeight: "21.45px",
  letterSpacing: "0.17px",
});

export const SubmitButton = styled(Button)({});

export const RemindMeLaterButton = styled(Button)({});

export const ReminderTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} arrow classes={{ popper: className }} />
))(({ _theme }) => ({
  [`& .${tooltipClasses.arrow}`]: {
    color: "#000",
  },
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#000",
    fontSize: 15,
    padding: "1rem",
  },
}));

export const SubmitButtonBox = styled(Box)({
  position: "relative",
});

export const SubmitButtonSpinner = styled(CircularProgress)({
  color: "#4700D7",
  position: "absolute",
  top: "50%",
  left: "50%",
  marginTop: "-12px",
  marginLeft: "-12px",
});
